import { useProduct } from "@/components/pdp/PdpDataContext";

// HP2-only trust band: the exact PDP3.1 animated icon marquee (unframed
// large chips, slow editorial cycle, hover-pauses, respects reduced motion),
// rendered on ALL devices under the hero.
const Chip = ({ item }) => (
  <div className="shrink-0 flex items-center mx-1.5 gap-4 px-7 py-4" aria-hidden="true">
    <span className="flex items-center justify-center rounded-full bg-riversol-blue/[0.06] shrink-0 w-12 h-12">
      <img src={item.icon} alt="" className="w-[22px] h-[22px]" loading="lazy" />
    </span>
    <span className="font-medium text-neutral-800 whitespace-nowrap text-[14px]">{item.label}</span>
  </div>
);

export const HighlightsMarquee = () => {
  const { highlights } = useProduct();
  if (!highlights) return null;
  const items = highlights.items;

  return (
    <section className="bg-white py-3 lg:py-4 -mt-14 lg:-mt-20" data-testid="home-highlights-marquee">
      <div className="relative overflow-hidden group">
        <div
          className="flex items-center animate-marquee-editorial [animation-play-state:running] group-hover:[animation-play-state:paused] motion-reduce:animate-none"
          style={{ width: "max-content" }}
        >
          {[...items, ...items, ...items].map((item, i) => (
            <Chip key={`hm-${i}`} item={item} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default HighlightsMarquee;
